module.exports = __webpack_public_path__ + "static/media/hanukiah.3a6dc4cb.svg";